import React from "react";
import { useQuery } from "@tanstack/react-query";
import { Star, BadgeCheck } from "lucide-react";
import api from "@/lib/api";
import ReviewsCarousel from "@/components/ReviewsCarousel";
import { Reveal, Stagger, staggerItem } from "@/components/Reveal";
import { motion } from "@/lib/motion";

export default function ReviewsPage() {
    const { data: reviews } = useQuery({ queryKey: ["reviews"], queryFn: async () => (await api.get("/reviews")).data });
    const list = reviews || [];

    return (
        <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
            <Reveal className="text-center">
                <p className="text-sm font-semibold uppercase tracking-widest text-caramel">Customer Reviews</p>
                <h1 className="mt-2 font-serif text-4xl font-semibold text-roast sm:text-5xl">Loved by pudding people everywhere</h1>
                <div className="mt-4 flex items-center justify-center gap-2 text-gold">
                    {Array.from({ length: 5 }).map((_, i) => <Star key={i} size={22} className="fill-gold" />)}
                    <span className="ml-2 font-medium text-roast">4.9 out of 5</span>
                </div>
            </Reveal>

            <div className="mt-14"><ReviewsCarousel reviews={list} /></div>

            <Stagger className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
                {list.map((r) => (
                    <motion.div key={r.id} variants={staggerItem} className="rounded-3xl border border-caramel/10 bg-white p-6 shadow-warm">
                        <div className="flex gap-1 text-gold">{Array.from({ length: 5 }).map((_, k) => <Star key={k} size={15} className={k < r.rating ? "fill-gold" : "opacity-30"} />)}</div>
                        <p className="mt-3 leading-relaxed text-roast/80">“{r.text}”</p>
                        <div className="mt-5 flex items-center gap-3">
                            <div className="grid h-10 w-10 place-items-center rounded-full bg-caramel text-sm font-semibold text-cream-50">{r.initials}</div>
                            <div>
                                <p className="flex items-center gap-1 text-sm font-medium text-roast">{r.name} {r.verified && <BadgeCheck size={14} className="text-caramel" />}</p>
                                <p className="text-xs text-mocha">{r.flavor}</p>
                            </div>
                        </div>
                    </motion.div>
                ))}
            </Stagger>
        </div>
    );
}
